import { Enquiry } from '../enquiry.schema';

const API_BASE_URL = import.meta.env.VITE_PUBLIC_WEB_FORM_SERVICE_API;

declare const grecaptcha: {
  ready: (callback: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
};

export class FormService {
  private static readonly RECAPTCHA_SITE_KEY = import.meta.env.VITE_PUBLIC_RECAPTCHA_SITE_KEY;

  static async executeRecaptcha(): Promise<string> {
    return new Promise((resolve) => {
      grecaptcha.ready(async () => {
        const token = await grecaptcha.execute(this.RECAPTCHA_SITE_KEY, { action: 'submit' });
        resolve(token);
      });
    });
  }

  static async submitForm(data: Enquiry): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE_URL}/enquiries`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (error) {
      console.error('Error submitting form:', error);
      return false;
    }
  }

  static loadRecaptchaScript(): void {
    if (!document.querySelector('#recaptcha-script')) {
      const script = document.createElement('script');
      script.id = 'recaptcha-script';
      script.src = `https://www.google.com/recaptcha/api.js?render=${this.RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }
}
